let xDown = undefined;
let yDown = undefined;
export default class Recipe {
    static initClass() {
        xDown = null;
        yDown = null;
    }

    constructor() {
        this.cooking_mode_gotostep = this.cooking_mode_gotostep.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.checkKey = this.checkKey.bind(this);
        this.initEvents();
    }

    cooking_mode_sidebar() {
        if ($(".cooking-mode").css("display") === "block") {
            const windowHeight = $(window).outerHeight();
            const logoHeight = $(".cooking-mode__sidebar__logo").outerHeight();
            const marginUl = parseInt(
                $(".cooking-mode__sidebar__logo").css("margin-bottom"),
                10
            );

            const visibleUl = windowHeight - logoHeight - marginUl;
            const heightLi =
                $(".cooking-mode__numbers li").outerHeight() +
                parseInt(
                    $(".cooking-mode__numbers li").css("margin-bottom"),
                    10
                );

            let numVisible = Math.floor(visibleUl / heightLi);

            const activeLi =
                $(".cooking-mode__numbers li.is-active").index() + 1;

            if (numVisible === 0) {
                numVisible = 1;
            }
            if (activeLi >= numVisible) {
                $(".cooking-mode__numbers li:first-child").css(
                    "margin-top",
                    -heightLi * (activeLi - numVisible) + "px"
                );
            } else {
                $(".cooking-mode__numbers li:first-child").css(
                    "margin-top",
                    "0px"
                );
            }

            return $(".cooking-mode__numbers").height(numVisible * heightLi);
        }
    }

    cooking_mode_gotostep(e) {
        if ($(".cooking-mode").css("display") === "block") {
            $(".js-close-tooltip").click();
            $(".js-cookingmode-prev").removeClass("is-disabled");
            $(".cooking-mode-next").removeClass("is-disabled");

            const max_steps = Number(
                $(".cooking-mode__wrapper").attr("data-max-steps")
            );
            const clicked = Number($(e.target).html());

            const next = (clicked - 1) * 100;
            $(".cooking-mode__wrapper").css("margin-left", -next + "%");

            if (clicked === max_steps) {
                $(".cooking-mode-next").addClass("is-disabled");
            }
            if (clicked === 1) {
                $(".cooking-mode-prev").addClass("is-disabled");
            }

            $(".cooking-mode__wrapper").attr("data-visible", clicked);
            $(".cooking-mode__numbers li").removeClass("is-active");
            $(`.cooking-mode__numbers li:eq(${clicked - 1})`).addClass(
                "is-active"
            );

            return this.cooking_mode_sidebar();
        }
    }

    cooking_mode_next() {
        if ($(".cooking-mode").css("display") === "block") {
            $(".js-close-tooltip").click();
            $(".js-cookingmode-prev").removeClass("is-disabled");
            const max_steps = Number(
                $(".cooking-mode__wrapper").attr("data-max-steps")
            );
            const visible = $(".cooking-mode__wrapper").attr("data-visible");

            const next = visible * 100;
            if (next <= (max_steps - 1) * 100) {
                $(".cooking-mode__wrapper").css("margin-left", -next + "%");

                if (Number(visible) + 1 === max_steps) {
                    $(".cooking-mode-next").addClass("is-disabled");
                }

                $(".cooking-mode__wrapper").attr(
                    "data-visible",
                    Number(visible) + 1
                );
                $(".cooking-mode__numbers li").removeClass("is-active");
                $(`.cooking-mode__numbers li:eq(${visible})`).addClass(
                    "is-active"
                );

                return this.cooking_mode_sidebar();
            }
        }
    }

    cooking_mode_prev() {
        if ($(".cooking-mode").css("display") === "block") {
            $(".cooking-mode-next").removeClass("is-disabled");

            const visible = $(".cooking-mode__wrapper").attr("data-visible");
            const prev = (visible - 2) * 100;

            if (prev >= 0) {
                $(".cooking-mode__wrapper").css("margin-left", -prev + "%");

                if (Number(visible) - 2 === 0) {
                    $(".js-cookingmode-prev").addClass("is-disabled");
                }

                $(".cooking-mode__wrapper").attr(
                    "data-visible",
                    Number(visible) - 1
                );
                $(".cooking-mode__numbers li").removeClass("is-active");
                $(`.cooking-mode__numbers li:eq(${visible - 2})`).addClass(
                    "is-active"
                );

                return this.cooking_mode_sidebar();
            }
        }
    }

    handleTouchStart(evt) {
        xDown = evt.touches[0].clientX;
        return (yDown = evt.touches[0].clientY);
    }

    handleTouchMove(evt) {
        if (!xDown || !yDown) {
            return;
        }

        const xUp = evt.touches[0].clientX;
        const yUp = evt.touches[0].clientY;
        const xDiff = xDown - xUp;
        const yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            /*most significant*/
            if (xDiff > 0) {
                /* left swipe */
                this.cooking_mode_next();
            } else {
                /* right swipe */
                this.cooking_mode_prev();
            }
        } else {
            if (yDiff > 0) {
            } else {
                /* up swipe */
            }
            /* down swipe */
        }

        /* reset values */
        xDown = null;
        return (yDown = null);
    }

    checkKey(e) {
        e = e || window.event;

        if (e.keyCode === 38) {
            // up arrow
        } else if (e.keyCode === 40) {
            // down arrow
        } else if (e.keyCode === 37) {
            // left arrow
            return this.cooking_mode_prev();
        } else if (e.keyCode === 39) {
            // right arrow
            return this.cooking_mode_next();
        }
    }

    initEvents() {
        //close tooltip
        $(".js-close-tooltip").on("click", function (e) {
            e.preventDefault();
            return $(this).parent().remove();
        });

        //check numbers sidebar
        $(window).on("resize", (e) => {
            return this.cooking_mode_sidebar();
        });

        //keyboard events
        $(document).on("keydown", (e) => {
            return this.checkKey(e);
        });

        //swipe events
        document.addEventListener("touchstart", this.handleTouchStart, false);
        document.addEventListener("touchmove", this.handleTouchMove, false);

        //cooking mode number clicked
        $(".js-cookingmode-number").on("click", (e) => {
            e.preventDefault();
            return this.cooking_mode_gotostep(e);
        });

        //cooking mode next clicked
        $(".js-cookingmode-next:not(.is-disabled)").on("click", (e) => {
            e.preventDefault();
            return this.cooking_mode_next();
        });

        //cooking mode prev clicked
        $(".js-cookingmode-prev").on("click", (e) => {
            e.preventDefault();
            return this.cooking_mode_prev();
        });

        //open cooking mode
        $(".js-open-cookingmode").on("click", (e) => {
            e.preventDefault();
            $(".cooking-mode").fadeIn(200, () => {
                return this.cooking_mode_sidebar();
            });
            return $("html, body").addClass("no-scroll");
        });

        //close cooking mode
        $(".js-close-cookingmode").on("click", function (e) {
            e.preventDefault();
            $(".cooking-mode").fadeOut(200);
            return $("html, body").removeClass("no-scroll");
        });

        //when num person change, change amount ingredients
        $(".recipe-persons select").on("change", function (e) {
            const default_amount = Number(
                $(".recipe-persons").attr("data-default-persons")
            );
            const persons = parseInt(this.value, 10);
            return $(".recipe-ingredient[data-amount]").each(function (
                index,
                element
            ) {
                let amount = parseFloat($(this).attr("data-amount"));
                if (amount !== 0) {
                    amount = (amount / default_amount) * persons;
                    amount = parseFloat(amount.toFixed(1));

                    if (amount === 0) {
                        amount = 1;
                    }

                    return $(element)
                        .find(".recipe-ingredient__amount")
                        .html(amount.toLocaleString("nl-BE"));
                }
            });
        });

        //close cooking mode label
        $(".js-close-cm-label").on("click", function (e) {
            e.preventDefault();
            return $(".cooking-mode-label").addClass("is-hidden");
        });

        $(".cooking-mode-button").on("mouseenter", function (e) {
            e.preventDefault();
            return $(".cooking-mode-label").removeClass("is-hidden");
        });

        $(".cooking-mode-button").on("mouseout", function (e) {
            e.preventDefault();
            return $(".cooking-mode-label").addClass("is-hidden");
        });

        //close product banner below header
        $(".js-close-product-banner").on("click", function (e) {
            e.preventDefault();
            return $(".recipe-product-banner").slideUp(200, function () {
                return $(this).remove();
            });
        });

        //logic to switch recipe tabs on mobile
        $(".recipe-headers .recipe-subtitle").on("click", function (e) {
            e.preventDefault();
            if (window.matchMedia("(max-width: 767px)").matches) {
                $(".recipe-headers .recipe-subtitle").removeClass("is-active");
                $(this).addClass("is-active");

                $(".recipe-tab").hide();
                return $(`.recipe-tab.${$(this).attr("data-goto")}`).show();
            }
        });

        //resize handler for recipe tab system
        $(window).on("resize", function (e) {
            if (window.matchMedia("(min-width: 768px)").matches) {
                $(".recipe-tab").show();
                $(".recipe-headers .recipe-subtitle").removeClass("is-active");
                return $(
                    ".recipe-headers .col-6:first-child .recipe-subtitle"
                ).addClass("is-active");
            }
        });

        //scroll handler for tooltip
        return $(window).on("scroll", function (e) {
            if ($(this).scrollTop() < 200) {
                return $(".cooking-mode-label").removeClass("is-hidden");
            } else {
                return $(".cooking-mode-label").addClass("is-hidden");
            }
        });
    }
}
